import * as go from 'gojs';
import { getImageImpactCrusherCI } from 'unitData/Crushers/ImpactCrusherCI/getImageImpactCrusherCI';
import { getImageBinding, getIOPort, makeNode } from '../../utils';

const ImpactCrusherCITemplate = makeNode(
  getImageBinding('showCustomModel', getImageImpactCrusherCI),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default ImpactCrusherCITemplate;
